import React, { useEffect, useState } from 'react';
import commonStyles from '../../Point.module.scss';
import styles from './Terminals.module.scss';
import { useSelector } from 'react-redux';
import { getTranslation } from '../../../../utils/translation';

// COMPONENTS
import BalanceTable from './Tables/BalanceTable';
import ResultTable from './Tables/ResultTable';
import Filters from './Filters/Filters';
import ContentSpinner from '../../../shared/Spinner/Spinner';

const TerminalsBalance = () => {
    const { terminalsBalance, loading } = useSelector(state => state.reports);

    const [totalData, setTotalData] = useState({
        total: 0,
        totalCount: 0,
        agentCommission: 0,
        debt: 0,
    });

    const [salesTable, setSalesTable] = useState({
        headings: [
            getTranslation('balanceReportSalesColumn'),
            getTranslation('balanceReportTicketCountColumn'),
            getTranslation('balanceReportAgentCommissionColumn'),
            getTranslation('balanceReportTotalSaleColumn'),
        ],
        body: [],
    });

    const [refundCommissionTable, setRefundCommissionTable] = useState({
        headings: [
            getTranslation('balanceReportRefundCommissionColumn'),
            getTranslation('balanceReportTicketCountColumn'),
            getTranslation('balanceReportAgentCommissionColumn'),
            getTranslation('balanceReportTotalRefundCommissionColumn'),
        ],
        body: [],
    });

    useEffect(() => {
        if (!terminalsBalance) return;

        const { sales, refundCommission, total } = terminalsBalance;

        // Sales table
        const {
            preMatchCount: salesPreMatchCount,
            liveCount: salesLiveCount,
            totalCount: salesTotalCount,
            preMatchTotal: salesPreMatchTotal,
            liveTotal: salesLiveTotal,
            total: salesTotal,
            preMatchAgentCommission: salesPreMatchAgentCommission,
            liveAgentCommission: salesLiveAgentCommission,
            agentCommissionTotal: salesAgentCommissionTotal,
        } = sales;

        setSalesTable(prev => {
            return {
                headings: prev.headings,
                body: [
                    [
                        getTranslation('balanceReportSportsBettingPrematch'),
                        salesPreMatchCount,
                        salesPreMatchAgentCommission,
                        salesPreMatchTotal,
                    ],
                    [
                        getTranslation('balanceReportSportsBettingLive'),
                        salesLiveCount,
                        salesLiveAgentCommission,
                        salesLiveTotal,
                    ],
                    [
                        getTranslation('balanceReportTotalColumn'),
                        salesTotalCount,
                        salesAgentCommissionTotal,
                        salesTotal,
                    ],
                ],
            };
        });

        // Refund Commission table
        const {
            preMatchCount: refundCommissionPreMatchCount,
            liveCount: refundCommissionLiveCount,
            totalCount: refundCommissionTotalCount,
            preMatchTotal: refundCommissionPreMatchTotal,
            liveTotal: refundCommissionLiveTotal,
            total: refundCommissionTotal,
            preMatchAgentCommission: refundCommissionPreMatchAgentCommission,
            liveAgentCommission: refundCommissionLiveAgentCommission,
            agentCommissionTotal: refundCommissionAgentCommissionTotal,
        } = refundCommission;
        setRefundCommissionTable(prev => {
            return {
                headings: prev.headings,
                body: [
                    [
                        getTranslation('balanceReportSportsBettingPrematch'),
                        refundCommissionPreMatchCount,
                        refundCommissionPreMatchAgentCommission,
                        refundCommissionPreMatchTotal,
                    ],
                    [
                        getTranslation('balanceReportSportsBettingLive'),
                        refundCommissionLiveCount,
                        refundCommissionLiveAgentCommission,
                        refundCommissionLiveTotal,
                    ],
                    [
                        getTranslation('balanceReportTotalColumn'),
                        refundCommissionTotalCount,
                        refundCommissionAgentCommissionTotal,
                        refundCommissionTotal,
                    ],
                ],
            };
        });

        // Total table
        setTotalData(totalData => ({
            ...totalData,
            total: total.total,
            agentCommission: total.agentCommission,
            debt: total.debt,
        }));
    }, [terminalsBalance]);

    return (
        <>
            <Filters />
            <main className={commonStyles.main}>
                <div className={styles.content}>
                    {loading ? (
                        <ContentSpinner />
                    ) : terminalsBalance ? (
                        <>
                            <div className={'m-b-12'} style={{ gridArea: 'table1' }}>
                                <BalanceTable data={salesTable} />
                            </div>

                            <div className={'m-b-12'} style={{ gridArea: 'table2' }}>
                                <BalanceTable data={refundCommissionTable} />
                            </div>

                            <div className={'m-b-12'} style={{ gridArea: 'table3' }}>
                                <ResultTable
                                    total={totalData.total}
                                    totalAgentCommission={totalData.agentCommission}
                                    debt={totalData.debt}
                                />
                            </div>
                        </>
                    ) : null}
                </div>
            </main>
        </>
    );
};

export default TerminalsBalance;
